import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const DocumentViewer = (props) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  // console.log('PDF File from Document viewer:-', props.pdfFile);

  return (
    props.pdfFile && (
        <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
          >
      <Viewer
        fileUrl={props.pdfFile}
        // fileUrl = 'http://127.0.0.1:3001/{props.pdfFile}'
        plugins={[defaultLayoutPluginInstance]}
      />
      </Worker>
    )
  );
};

export default DocumentViewer;

// // PDFViewer.js
// import React from 'react';
// import { Viewer } from '@react-pdf-viewer/core';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// // Import required CSS
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// const PDFViewer = ({ fileUrl }) => {
//   const defaultLayoutPluginInstance = defaultLayoutPlugin();
  
//   // Ensure fileUrl is a string
//   const safeFileUrl = typeof fileUrl === 'string' ? fileUrl : '';
  
//   return (
//     <div style={{ height: '750px', width: '100%' }}>
//       {safeFileUrl ? (
//         <Viewer
//           fileUrl={safeFileUrl}
//           plugins={[defaultLayoutPluginInstance]}
//         />
//       ) : (
//         <div className="alert alert-info">No PDF file selected or invalid URL</div>
//       )}
//     </div>
//   );
// };

// export default PDFViewer;